import React from 'react';
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableContainer,
  Pagination
} from 'carbon-components-react';
import { Header } from 'redux/member/types';
import DisplayEmailRow from './row';
import EmptyStatePage from './empty';

const PageSizes = [10, 20, 50];

const EmailsTables: React.FC<Props> = ({
  isRefferal,
  emails = [],
  currentPage,
  pageSize,
  totalItems,
  handlePageChange,
  handleViewDetail,
  handleResend,
  handlePreviewEmail,
  handleDownload,
  handleSendToOther
}) => {
  const headers: Array<Header> = [
    {
      key: 'sent',
      header: 'Sent'
    },
    { key: 'referral', header: 'Referral' },
    {
      key: isRefferal ? 'job' : 'to',
      header: isRefferal ? 'JobNumber' : 'To'
    },
    { key: 'status', header: 'Status' },
    { key: 'disableEmailResend', header: '' }
  ];

  const getInboundEmailId = (id: string) => {
    const email = emails.find((e) => e.id === id);
    return email?.inboundEmailId;
  };

  return (
    <>
      <DataTable rows={emails || []} headers={headers}>
        {({ rows, getTableProps, getHeaderProps, getRowProps }: any) => {
          return (
            <TableContainer>
              <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    <TableHeader
                      key="sent"
                      {...getHeaderProps({ key: 'sent', header: 'Sent' })}
                    >
                      {isRefferal ? 'Sent' : 'Received'}
                    </TableHeader>
                    <TableHeader
                      key="referral"
                      {...getHeaderProps({
                        key: 'referral',
                        header: 'Referral'
                      })}
                    >
                      Referral
                    </TableHeader>
                    {isRefferal ? (
                      <TableHeader
                        key="job"
                        {...getHeaderProps({ key: 'job', header: 'JobNumber' })}
                      >
                        Job number
                      </TableHeader>
                    ) : (
                      <TableHeader
                        key="to"
                        {...getHeaderProps({ key: 'to', header: 'To' })}
                      >
                        Destination email
                      </TableHeader>
                    )}

                    <TableHeader
                      key="status"
                      {...getHeaderProps({ key: 'status', header: 'Status' })}
                    >
                      Delivery status
                    </TableHeader>
                    <TableHeader />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row: any, index: any) => (
                    <DisplayEmailRow
                      isRefferal={isRefferal}
                      inboundEmailId={getInboundEmailId(row.id)}
                      row={row}
                      getRowProps={getRowProps}
                      key={index}
                      handleViewDetail={handleViewDetail}
                      handleResend={handleResend}
                      handleDownload={handleDownload}
                      handlePreviewEmail={handlePreviewEmail}
                      handleSendToOther={handleSendToOther}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          );
        }}
      </DataTable>

      {emails.length < 1 && <EmptyStatePage />}
      {emails.length >= 1 && (
        <Pagination
          onChange={(data) => handlePageChange(data)}
          backwardText="Previous page"
          forwardText="Next page"
          itemsPerPageText="Items per page:"
          page={currentPage}
          pageNumberText="Page Number"
          pageSize={pageSize}
          pageSizes={PageSizes}
          totalItems={totalItems}
        />
      )}
    </>
  );
};

type Props = {
  isRefferal: boolean;
  emails?: any[];
  currentPage: number;
  pageSize: number;
  totalItems: number;
  handlePageChange: Function;
  handleViewDetail: Function;
  handleResend: Function;
  handlePreviewEmail: Function;
  handleDownload: Function;
  handleSendToOther: Function;
};

export default React.memo(EmailsTables);
